export default __webpack_public_path__ + "static/media/thumbnail1.ac6615b3.jpg";